<template>
    <v-container id="general-report" fluid tag="section">
        <filter-form :filterForm="filterForm" />
        <general-report-table
            :totalData="totalData"
            :initArpu="initArpu"
            :initLatch="initLatch"
            :initTurnOver="initTurnOver"
            :successArpu="successArpu"
            :successLatch="successLatch"
            :successTurnOver="successTurnOver"
            :header="header" />
    </v-container>
</template>

<script>
import FilterForm from './components/FilterForm'
import GeneralReportTable from './components/GeneralReportTable'
import moment from 'moment'
import RepositoryFactory from "@/repositories/RepositoryFactory"

const ReportRepository = RepositoryFactory.get('report')

export default {
    components: { FilterForm, GeneralReportTable },
    data() {
        return {
            filterForm: {
                dateRange: {
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                }
            },
            totalData: {},
            initArpu: [],
            initLatch: [],
            initTurnOver: [],
            successArpu: [],
            successLatch: [],
            successTurnOver: [],
            header: []
        }
    },
    created() {
        this.getGeneralReport()
        Bus.$on('general-report-list-filter', filterForm => {
            this.filterForm = filterForm
            this.getGeneralReport()
        })
    },
    methods: {
        async getGeneralReport() {
            const loading = this.$loading.show()
            const params = {
                startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
                endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
            }
            
            const res = await ReportRepository.generalReport(params)
            if (res.success) {
                this.totalData = _.get(res, 'data.total', {})
                this.initArpu = _.get(res, 'data.detail.initArpu', [])
                this.initLatch = _.get(res, 'data.detail.initLatch', [])
                this.initTurnOver = _.get(res, 'data.detail.initTurnOver', [])
                this.successArpu =  _.get(res, 'data.detail.successArpu', [])
                this.successLatch = _.get(res, 'data.detail.successLatch', [])
                this.successTurnOver = _.get(res, 'data.detail.successTurnOver', [])
                this.header = _.get(res, 'data.header', [])
            } else {
                this.totalData = {}
                this.initArpu = []
                this.initLatch = []
                this.initTurnOver = []
                this.successArpu = []
                this.successLatch = []
                this.successTurnOver = []
                this.header = []
            }
            loading.hide()
        }
    }
}
</script>

<style scoped>

</style>